import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { DISPLAY_LANG } from '../../../config';
import { getHeaderUserInfo, getHeaderUserData } from '../../../api/user/header';
import './AccountData.css';

export default function AccountData() {
    const [user, setUser] = useState(null);
    const [pageData, setPageData] = useState(null);
    const [show, setShow] = useState(false);
    const dropdownRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        const loadingData = async () => {
            try {
                const userID = localStorage.getItem('user_id');
                const resUserInfo = await getHeaderUserInfo(userID);
                setUser(resUserInfo);

                const resPageData = await getHeaderUserData();
                setPageData(resPageData);
            } catch (error) {
                console.log(error);
            }
        };

        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShow(false);
            }
        };

        loadingData();

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handlerLogOut = () => {
        localStorage.clear();
        window.location.href = '/';
    };

    if (!user || !pageData) return null;

    return (
        <div className='account-data flex-center'>
            <div className="account-balance">
                <span>{pageData && pageData.balanceLabel[DISPLAY_LANG]}</span>

                <div className="balance-content flex-between">
                    <div className="balance">{user.balance}</div>
                    <img src="/images/partials/plus.svg" alt="plus" />
                </div>
            </div>

            <div className="account-settings flex-center" ref={dropdownRef}>
                <Link to={'/user'}>
                    <div className='flex-center user'>
                        <img
                            src="/images/partials/account-avatar.svg"
                            alt="account-avatar"
                            className='avatarimg'
                            onClick={() => navigate('/user')}
                        />

                        <img
                            src="/images/partials/arrow.svg"
                            onClick={() => setShow(prev => !prev)}
                            className={`arrow ${show ? 'show' : ''}`}
                            alt="arrow-right"
                        />
                    </div>
                </Link>

                {show && <div className="dropdown" onClick={(e) => e.stopPropagation()}>
                    <p className="username">{pageData.hiLabel[DISPLAY_LANG]} {user.full_name}</p>

                    <div className="content">
                        <Link to={'/'}>{pageData.settingsLabel[DISPLAY_LANG]}</Link>
                        <Link to={'/'}>{pageData.ticketLabel[DISPLAY_LANG]}</Link>
                        <Link to={'/'}>{pageData.paymentLabel[DISPLAY_LANG]}</Link>
                    </div>

                    <button className='logout' onClick={handlerLogOut}>
                        {pageData.logoutLabel[DISPLAY_LANG]}
                    </button>
                </div>}
            </div>
        </div>
    )
}